import React, { useState } from "react";
import { toast } from "react-toastify";

import { RATING_LABEL, updateApplicationApi, type ApplicantRating } from "../campanhasApi";

const RATINGS: ApplicantRating[] = ["BOM", "MEDIO", "RUIM"];

type Props = {
  applicationId: string;
  value: ApplicantRating | null;
  /** Depois de gravar: a lista atualiza a linha e as contagens. */
  onChange: (next: ApplicantRating | null) => void;
  size?: "sm" | "md";
};

/**
 * Avaliação do candidato com um clique: bom, médio ou ruim. Clicar de novo na
 * marcada volta para pendente. Grava na hora e não bloqueia nada.
 */
const RatingButtons: React.FC<Props> = ({ applicationId, value, onChange, size = "sm" }) => {
  const [busy, setBusy] = useState(false);

  const rate = async (e: React.MouseEvent, rating: ApplicantRating) => {
    e.stopPropagation();
    const next = value === rating ? null : rating;
    try {
      setBusy(true);
      await updateApplicationApi(applicationId, { rating: next });
      onChange(next);
    } catch (err: any) {
      toast.error(err?.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <span className={`cmpRate cmpRate--${size}`} role="group" aria-label="Avaliação do candidato">
      {RATINGS.map((r) => (
        <button
          key={r}
          type="button"
          className={`cmpRate__btn cmpRate__btn--${r.toLowerCase()}${value === r ? " is-active" : ""}`}
          aria-pressed={value === r}
          title={value === r ? "Clique de novo para voltar a pendente" : `Marcar como ${RATING_LABEL[r].toLowerCase()}`}
          onClick={(e) => rate(e, r)}
          disabled={busy}
        >
          {RATING_LABEL[r]}
        </button>
      ))}
    </span>
  );
};

export default RatingButtons;
